export default __webpack_public_path__ + "static/media/about.85e221ab.svg";